import React, { FC, useCallback } from 'react';
import useWidgetContext from '../../../../../common/react/useWidgetContext';
import usePlatformConfig from '../../../../../common/react/usePlatformConfig';
import SummaryCarView from '../../../summary/components/summaryViews/SummaryCarView';
import SummaryContext from '../../../../common/context/SummaryContext';
import { useHistory } from 'react-router';
import { Routes } from '../../../../../common/enum/Routes';
import { ICheckoutTheme } from 'src/common/theme/ICheckoutTheme';
import { useTheme } from '@material-ui/core';
import useDealData from '../../../common/hooks/useDealData';

const VehicleSummary: FC = () => {
  const {
    configuration: { dimensions },
  } = useWidgetContext();
  const {
    checkoutLite: {
      summary: { hideReservationDetails, hideDriveawayPrice },
    },
  } = useTheme<ICheckoutTheme>();
  const history = useHistory();
  const redirectUnavailableDeal = useCallback(() => history.replace(Routes.DEAL_UNAVAILABLE, {}), []);
  const { dealData } = useDealData();
  const {
    platformConfig: {
      priceDisplay,
      platformFeatures: { complexModel },
    },
  } = usePlatformConfig();

  if (!dealData) {
    return null;
  }

  if (!dealData.car?.prices) {
    redirectUnavailableDeal();

    return null;
  }

  const financeDisclaimerBreakdown = dealData.finance?.breakdown;

  return (
    <SummaryContext.Provider value={{ dimensions, priceDisplay, financeDisclaimerBreakdown }}>
      <SummaryCarView
        complexModel={complexModel}
        car={dealData.car}
        financeSimulation={dealData.finance?.simulation}
        priceDisplay={priceDisplay}
        isCarEditable={true}
        isExtendable={true}
        dimensions={dimensions}
        dealAttributes={dealData.attributes}
        hideReservationDetails={hideReservationDetails}
        hideDriveawayPrice={hideDriveawayPrice}
        expressionsOfInterest={dealData.expressionsOfInterest}
      />
    </SummaryContext.Provider>
  );
};

export default VehicleSummary;
